
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 144 144","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M72 12c-33.18 0-60 26.82-60 60s26.82 60 60 60 60-26.82 60-60-26.82-60-60-60zm15.54 36L72 63.54 56.46 48 48 56.46 63.54 72 48 87.54 56.46 96 72 80.46 87.54 96 96 87.54 80.46 72 96 56.46 87.54 48zM24 72c0 26.46 21.54 48 48 48s48-21.54 48-48-21.54-48-48-48-48 21.54-48 48z","fill":"#ABABAB"}})])
          )
        }
      }
    